export { };
declare global {
  interface String {
    normalizar(this: string): string;
    capitalizeFirstLetter(this: string): string;
    toNumber(this: string): number;
    removerMascara(this: string): string;
  }
  interface Number {
    toMoney(this: number): string;
  }
}

String.prototype.normalizar = function (this: string): string {
  return this?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '') // Remove acentos
    ?.replace(/([^\w]+|\s+)/g, '-') // Substitui espaço e outros caracteres por hífen
    ?.replace(/\-\-+/g, '-')	// Substitui multiplos hífens por um único hífen
    ?.replace(/(^-+|-+$)/, '') // Remove hífens extras do final ou do inicio da string
    ?.toLowerCase();
};

String.prototype.removerMascara = function (this: string): string {
  return this?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '') // Remove acentos
    ?.replace(/([^\w]+|\s+)/g, ''); // Remove espaço e outros caracteres
};

String.prototype.capitalizeFirstLetter = function (this: string): string {
  return this && this.length > 1 ? this.charAt(0).toUpperCase() + this.slice(1)?.toLowerCase() : this;
}

String.prototype.toNumber = function (this: string): number {
  if (!this)
    return NaN;

  // Realiza os replace apenas se a string tiver mais de 1 '.'
  // ou possua ',' nesses casos está no formato pt-br
  if (this.includes(',') || (this.match(/\./g)?.length ?? 0) > 1) {
    var valor = this.replace(/\./g, '').replace(/\,/g, '.');
    return parseFloat(valor);
  } else {
    return parseFloat(this);
  }
}

Number.prototype.toMoney = function (this: number): string {
  return (Math.round((this + Number.EPSILON) * 100) / 100)
    .toLocaleString('pt-BR', {
      currency: 'BRL',
    });
}
